import React, { useEffect, useState } from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../../config/config";

function EventTourDetails() {
  const { id } = useParams();
  const { t, i18n } = useTranslation();
  const [event, setEvent] = useState(null);
  const [tours, setTours] = useState([]);

  const getLocalizedValue = (item, field) => {
    if (!item) return "";
    const langFieldMap = { ru: "Ru", tj: "Tj", en: "En" };
    const suffix = langFieldMap[i18n.language] || "Ru";
    return item[`${field}${suffix}`] || item[field] || "";
  };

  useEffect(() => {
    if (!id) return;
    const langMap = { tj: 1, ru: 2, en: 3 };
    const langCode = langMap[i18n.language] || 2;

    axios
      .get(`${API_BASE_URL}/api/events/get-tour-by-id/${id}?lang=${langCode}`, {
        headers: { accept: "text/plain", "api-version": "1.0" },
      })
      .then((res) => setEvent(res.data))
      .catch((err) => console.error("Error fetching tour:", err));

    axios
      .get(`${API_BASE_URL}/api/events/events-tours?lang=${langCode}`, {
        headers: { accept: "text/plain", "api-version": "1.0" },
      })
      .then((res) => setTours(res.data.entities || res.data))
      .catch((err) => console.error("Error fetching tours:", err));
  }, [id, i18n.language]);

  if (!event)
    return <div className="p-5 text-center text-muted">{t("No data")}</div>;

  return (
    <Container fluid className="bg-light py-5">
      <Container className="py-4">
        <h2
          className="mb-4 fw-bold"
          style={{ fontSize: "2rem", color: "#2c3e50" }}
        >
          {t("showToursTitle")}
        </h2>

        <Row className="g-4">
          <Col xs={12} md={7}>
            <Card className="shadow-lg border-0 rounded-4 overflow-hidden">
              {event.image && (
                <Card.Img
                  variant="top"
                  src={event.image}
                  alt={getLocalizedValue(event, "title")}
                  className="img-fluid hover-scale"
                  style={{
                    maxHeight: "450px",
                    objectFit: "cover",
                    transition: "transform 0.3s ease",
                  }}
                />
              )}
              <Card.Body className="p-4">
                <Card.Title
                  className="mb-3 fw-bold"
                  style={{
                    fontSize: "1.9rem",
                    lineHeight: "2.2rem",
                    color: "#2c3e50",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: getLocalizedValue(event, "title"),
                  }}
                ></Card.Title>
                <Card.Text
                  className="mb-4 text-muted"
                  style={{ fontSize: "1rem", lineHeight: "1.8" }}
                  dangerouslySetInnerHTML={{
                    __html: getLocalizedValue(event, "longDesc"),
                  }}
                ></Card.Text>
                <Button
                  as={Link}
                  to="/deatel"
                  className="fw-semibold py-2 px-4 rounded-3 shadow-sm"
                  style={{
                    backgroundColor: "#6D9273",
                    border: "none",
                    transition: "background-color 0.3s",
                  }}
                >
                  {t("discover.backToTours")}
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} md={5}>
            <h4
              className="mb-3 fw-bold"
              style={{ fontSize: "1.3rem", color: "#2c3e50" }}
            >
              {t("discover.allTours")}
            </h4>
            {tours.length === 0 ? (
              <p className="text-muted">{t("No tours available")}</p>
            ) : (
              <div className="d-flex flex-column gap-3">
                {tours.map((tour) => (
                  <Link
                    key={tour.id}
                    to={`/tours/show/${tour.id}`}
                    state={{ event: tour }}
                    className="text-decoration-none"
                    style={{ color: "inherit" }}
                  >
                    <Card
                      className="shadow-sm border-0 rounded-4 overflow-hidden hover-shadow"
                      style={{
                        transition: "transform 0.3s, box-shadow 0.3s",
                        cursor: "pointer",
                      }}
                    >
                      {tour.image && (
                        <Card.Img
                          variant="top"
                          src={tour.image}
                          alt={getLocalizedValue(tour, "title")}
                          style={{
                            maxHeight: "150px",
                            objectFit: "cover",
                            transition: "transform 0.3s",
                          }}
                          className="hover-scale"
                        />
                      )}
                      <Card.Body>
                        <Card.Title
                          className="mb-3 fw-bold"
                          style={{
                            fontSize: "1.9rem",
                            lineHeight: "2.2rem",
                            color: "#2c3e50",
                          }}
                          dangerouslySetInnerHTML={{
                            __html: getLocalizedValue(event, "title"),
                          }}
                        ></Card.Title>
                        <Card.Text
                          className="text-muted"
                          style={{
                            fontSize: "0.95rem",
                            lineHeight: "1.6",
                            color: "#555",
                          }}
                          dangerouslySetInnerHTML={{
                            __html: getLocalizedValue(tour, "shortDesc"),
                          }}
                        />
                      </Card.Body>
                    </Card>
                  </Link>
                ))}
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default EventTourDetails;
